import { Router, RouterModule } from '@angular/router';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { loadRoutes, APP_ROUTES } from './app.routes';

function initializeRoutes(router: Router): () => Promise<void> {
  return async () => {
    await loadRoutes();

    router.resetConfig(APP_ROUTES);
  };
}

@NgModule({
  imports: [RouterModule.forRoot([])],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: initializeRoutes,
      deps: [Router],
      multi: true
    }
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
